import InputLabel from './InputLabel';
export default InputLabel;
